module.exports = __webpack_public_path__ + "img/currency4.fe26d188.png";